import {
  AsyncState,
  Updater,
  loadingAsyncState
} from 'widgets-for-react'
import { ArticlePage } from '../cmsPage/cmsPageState'
import { PageResult } from '../cmsPage/sharepointPageApi/types/pageData'
import {
  allPaginatedArticlesApi,
  featuredArticlesApi,
  semiFeaturedArticlesApi
} from './magazinesOverviewApi'

export type RegularArticlesState = {
  regularArticlesResult: AsyncState<PageResult<ArticlePage>>,
  page: number
}

export type MagazinesOverviewPageState = {
  featuredArticles: AsyncState<ArticlePage[]>
  semiFeaturedArticles: AsyncState<ArticlePage[]>
  regularArticles: RegularArticlesState
}

export const initialMagazinesOverviewState = (
  page?: string
) : MagazinesOverviewPageState => {
  const intPage = parseInt((page || '1'));
  return {
    featuredArticles: loadingAsyncState(() => featuredArticlesApi()),
    semiFeaturedArticles: loadingAsyncState(() => semiFeaturedArticlesApi()),
    regularArticles: {
      regularArticlesResult: loadingAsyncState(() => allPaginatedArticlesApi(intPage)),
      page: intPage
    }
  }
}

export const magazinesOverviewStateUpdaters = {
  updatefeaturedArticles: (updater: Updater<AsyncState<ArticlePage[]>>) => (
    state: MagazinesOverviewPageState
  ): MagazinesOverviewPageState => ({
    ...state,
    featuredArticles: updater(state.featuredArticles)
  }),
  updateSemiFeaturedArticles: (updater: Updater<AsyncState<ArticlePage[]>>) => (
    state: MagazinesOverviewPageState
  ): MagazinesOverviewPageState => ({
    ...state,
    semiFeaturedArticles: updater(state.featuredArticles)
  }),
  updateRegularArticlesResult: (
    updater: Updater<AsyncState<PageResult<ArticlePage>>>
  ) => (state: MagazinesOverviewPageState): MagazinesOverviewPageState => ({
    ...state,
    regularArticles: {
      ...state.regularArticles,
      regularArticlesResult: updater(state.regularArticles.regularArticlesResult)
    }
  })
}
